import React from 'react';
import { Avatar } from '../Avatar/Avatar';

type Props = {
  imageUrls: string[]
};

export const AvatarFlower = ({ imageUrls }: Props): JSX.Element => (
    <div className='flex flex-row h-60'>
      <div className='flex'>
        <div className='self-center animate-grow'>
          <Avatar imageUrl={imageUrls[0]} size={97} />
        </div>
      </div>
      <div className='flex flex-col -mr-8 -ml-7'>
        <div className='flex animate-grow'>
          <Avatar imageUrl={imageUrls[1]} size={77} />
        </div>
        <div className='flex-1'/>
        <div className='flex animate-grow'>
          <Avatar imageUrl={imageUrls[2]} size={77} />
        </div>
      </div>
      <div className='flex'>
        <div className='self-center animate-grow'>
          <Avatar imageUrl={imageUrls[3]} size={68} />
        </div>
      </div>
      <div className='flex flex-col -mx-4'>
        <div className='flex pt-6 animate-grow'>
          <Avatar imageUrl={imageUrls[4]} size={59} />
        </div>
        <div className='flex flex-1'  />
        <div className='flex pb-6 animate-grow'>
          <Avatar imageUrl={imageUrls[5]} size={59} />
        </div>
      </div>
      <div className='flex -ml-2.5'>
        <div className='self-center animate-grow'>
          <Avatar imageUrl={imageUrls[6]} size={46} />
        </div>
      </div>
    </div>
  );
